import React from 'react';
import { Chip } from '@/components/ui-ios';
export default function CourierBadge({ name }) {
  const lower = (name || '').toLowerCase();
  let tone = 'neutral';
  if (lower.includes('postacentrale')) tone = 'orange';
  else if (lower.includes('fulmine')) tone = 'blue';
  return <Chip tone={tone} testid={`corriere-badge-${(name || 'na').toLowerCase()}`}>{name || '—'}</Chip>;
}
